module.exports = __webpack_public_path__ + "img/card3.75bac76e.png";